export default __webpack_public_path__ + "static/media/red_x.afac9c65.svg";